import { API } from "./types";

const apiConfig = ({ params: _ }: {
  params: API.Params,
}) => ({
  baseUrl: _.url,
  headers: { Authorization: `Bearer ${_.key}` },
});

export async function api({ params }: {
  params: API.Params,
}): Promise<API.Service> {
  const config = apiConfig({ params });

  return {
    GET: async ({ endpoint }: { endpoint: string }) => {
      try {
      const response = await fetch(`${config.baseUrl}/${endpoint}`, {
          headers: config.headers,
        });
        if (!response.ok) {
          console.error(`API GET request to ${endpoint} failed: HTTP ${response.status}`);
          return undefined;
        }
        return response.json();
      } catch (error) {
        console.error(`API GET request to ${endpoint} failed:`, error);
        return undefined;
      }
    }
  };
}
